import React        from 'react';
import { Link }     from 'react-router-dom';
import classNames   from 'classnames';

import { Fa }             from '../../atoms/Icons/Fa';
import { Block }          from '../../atoms/Layout/Block/Block';
import { GridCell }       from '../../atoms/Layout/GridCell/GridCell';
import { GridRow }        from '../../atoms/Layout/GridRow/GridRow';
import { Slider }         from '../../atoms/Slider/Slider';
import { H2 }             from '../../atoms/Text/Headings';
import { Text }           from '../../atoms/Text/Text';
import { Game }           from '../../models/Game';
import { GameTile }       from '../Tiles/GameTile';
import styles             from './Recommendations.css';
import { Categories }     from '../../constants/Pages';

type RecommendationsProps = {
    title: string;
    description: string;
    games: Game[];
    viewMoreLink?: string;
    className?: string;
};

export class Recommendations extends React.PureComponent<RecommendationsProps> {
    render() {
        const {
            title, description, viewMoreLink, className
        } = this.props;

        const games = this.props.games.map((game, index) => (
            <Cell key = {index} size = {4}>
                <GameTile
                    key = {index}
                    game = {game}
                    position = {index}
                    promoBoxSlotTitle = {title}
                />
            </Cell>
        ));

        const attributes = (title === Categories.Juegos.toString()) ? {lang:'es'} : null;
        
        const viewMoreNode = viewMoreLink ? (
            <ViewMore to = {viewMoreLink} aria-label = {`View more ${title} games`}>
                <ViewMoreText bold = {true}>
                    View More
                </ViewMoreText>

                <Fa icon = "angle-right" />
            </ViewMore>
        ) : null;

        return (
            <Block data-element-description = {description} className = {className}>
                <Heading>
                    <HeadingText size = {'h2'} {...attributes}>
                        {title}
                    </HeadingText>
                    {viewMoreNode}
                </Heading>

                <GamesSlider>
                    <GamesList gamesCount = {games.length}>
                        {games}
                    </GamesList>
                </GamesSlider>
            </Block>
        );
    }
}

const Heading = (props: any) => <div className = {styles.heading} {...props} />;
const HeadingText = (props: any) => <H2 className = {styles.headingText} {...props} />;
const ViewMore = (props: any) => <Link className = {styles.viewMore} {...props} />;
const ViewMoreText = (props: any) => <Text className = {styles.viewMoreText} {...props} />;

const GamesSlider = (props: any) => (<Slider className = {styles.gamesSlider} {...props} />);

const GamesList = ({gamesCount, ...props}: any) => (
    <GridRow
        className = {classNames(styles.gamesList, {[styles.overflowed] : gamesCount >= 3})}
        {...props}
    />
);
const Cell = (props: any) => <GridCell className = {styles.gameCell} {...props} />;
